<template>
    <v-list-group
        dark
        :style="styles"
        :ripple="false"
        :value="searchField.id === open"
    >
        <v-list-item
            dark
            :ripple="false"
            slot="activator"
            class="megatrend"
        >
            <v-list-item-content>
                <v-list-item-title>
                    <div>
                        {{ searchField.title }}
                        <span class="v-list-item__subtitle float-right">{{ status }}</span>
                    </div>
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <macrotrend-evaluation
            v-for="macrotrend in searchField.macrotrends"
            :macrotrend="macrotrend"
            :search-field-id="searchField.id"
            :key="macrotrend.id"
        />
    </v-list-group>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

import MacrotrendEvaluation from './macrotrend'

@Component({
    components: {
        MacrotrendEvaluation
    }
})
export default class SearchFieldEvaluation extends Vue {
  @Prop({ type: Object, required: true }) searchField
  @Prop({ type: String, default: () => null }) open

  get styles () {
      return {
          'background-color': this.searchField.color,
          color: 'white'
      }
  }

  get status () {
      let todo = 0
      this.searchField.macrotrends.forEach(elem => {
          todo += elem.evaluations === null ? 1 : 0
      })
      return this.$tc('status', todo, { cnt: todo })
  }
}
</script>

<style lang="sass"
       scoped>
  .v-list-item.theme--dark.megatrend
    padding-left: 0
    padding-right: 0
</style>

<i18n>
{
  "de": {
    "status": "Alle Macro-Trends bewertet|{cnt} Macro-Trend zu bewerten|{cnt} Macro-Trends zu bewerten"
  },
  "en": {
    "status": "All macro-trends rated|Rate {cnt} macro-trend|Rate {cnt} macro-trends"
  }
}
</i18n>
